import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-浦东发展银行",
  "use": "icon-浦东发展银行-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-浦东发展银行\"><defs><style type=\"text/css\"></style></defs><path d=\"M406.144 361.4208c-94.90944-187.392-335.14496-158.75072-387.8656 0.65024 0 0-7.35232 51.712-13.12256 105.55904L5.12 794.38336l154.28608 144.85504 0.07168-398.848c-0.00512 0 16.71168-190.6432 246.66624-178.9696z m-226.32448 304.1536s253.30176 34.89792 262.02112-224.13824c-4.0448-243.2512 308.224-259.34848 393.0624-84.43392 0 0-221.28128 2.89792-244.5824 186.3424 0 0 2.9184 226.27328-171.77088 249.55392 0-0.00512-189.21984 32.8192-238.73024-127.32416z m438.016-2.9952c94.94528 187.38688 330.79808 156.544 383.53408-2.88256 0 0 16.00512-36.54144 17.4592-103.36256l0.0512-326.72256-154.30144-144.84992-0.03584 398.83776s-16.73728 190.67904-246.7072 178.97984z\" fill=\"#1D2087\" p-id=\"5748\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/浦东发展银行.svg
// module id = Hq2U
// module chunks = 107